import React, { useState, useEffect } from "react";
import { getActiveEmployees } from "../../../../api/ticketing";
import { apiClient } from "../../../../api/apiclient";
import { toast } from "react-toastify";

const ReassignModal = ({ ticket, onClose, onSaved }) => {
  const token = localStorage.getItem("token");
  const [employees, setEmployees] = useState([]);
  const [assigneeId, setAssigneeId] = useState(ticket?.assigneeId || "");
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getActiveEmployees(token)
      .then(res => setEmployees(res.data))
      .catch(() => { });
  }, [token]);

  if (!ticket) return null;

  const handleConfirm = async () => {
    if (!assigneeId) { toast.warning("Please select an assignee"); return; }
    setSaving(true);
    try {
      await apiClient.patch(`/tickets/${ticket.id}/reassign`,
        { assigneeId: parseInt(assigneeId), reason },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Ticket reassigned successfully");
      onSaved();
      onClose();
    } catch {
      toast.error("Failed to reassign ticket");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div onClick={onClose} style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1400,
      }} />

      {/* Modal */}
      <div style={{
        position: "fixed", top: "50%", left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff", borderRadius: 12, width: 400,
        boxShadow: "0 8px 40px rgba(0,0,0,0.18)", zIndex: 1401,
        overflow: "hidden",
      }}>
        {/* Header */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "18px 20px 14px", borderBottom: "1px solid #f0f0f0",
        }}>
          <span style={{ fontWeight: 700, fontSize: 15, color: "#111827" }}>Reassign Ticket</span>
          <button onClick={onClose} style={{
            background: "none", border: "none", fontSize: 20,
            cursor: "pointer", color: "#9ca3af", lineHeight: 1,
          }}>×</button>
        </div>

        {/* Body */}
        <div style={{ padding: "18px 20px" }}>
          {/* Assignee */}
          <div style={{ marginBottom: 16 }}>
            <label style={{
              display: "block", fontSize: 12, fontWeight: 600,
              color: "#374151", marginBottom: 6,
            }}>
              Assignee
            </label>
            <select
              value={assigneeId}
              onChange={e => setAssigneeId(e.target.value)}
              style={{
                width: "100%", height: 40, border: "1px solid #e5e7eb",
                borderRadius: 8, padding: "0 12px", fontSize: 13,
                background: "#f9fafb", color: "#374151", outline: "none",
              }}
            >
              <option value="">Assign user</option>
              {employees.map(emp => (
                <option key={emp.id} value={emp.id}>
                  {emp.name}
                </option>
              ))}
            </select>
          </div>

          {/* Reason */}
          <div>
            <label style={{
              display: "block", fontSize: 12, fontWeight: 600,
              color: "#374151", marginBottom: 6,
            }}>
              Reason (Optional)
            </label>
            <textarea
              value={reason}
              onChange={e => setReason(e.target.value)}
              rows={3}
              placeholder="Enter reason for reassignment..."
              style={{
                width: "100%", border: "1px solid #e5e7eb",
                borderRadius: 8, padding: "9px 12px", fontSize: 13,
                background: "#f9fafb", color: "#374151", outline: "none",
                resize: "vertical", fontFamily: "inherit", boxSizing: "border-box",
              }}
            />
          </div>
        </div>

        {/* Footer */}
        <div style={{
          display: "flex", justifyContent: "flex-end", gap: 10,
          padding: "14px 20px", borderTop: "1px solid #f0f0f0",
        }}>
          <button onClick={onClose} style={{
            padding: "7px 20px", border: "1px solid #d1d5db",
            borderRadius: 6, background: "#fff", color: "#374151",
            fontSize: 13, fontWeight: 500, cursor: "pointer",
          }}>
            Cancel
          </button>
          <button onClick={handleConfirm} disabled={saving} style={{
            padding: "7px 20px", border: "none",
            borderRadius: 6, background: "#2563eb", color: "#fff",
            fontSize: 13, fontWeight: 600, cursor: "pointer",
            opacity: saving ? 0.7 : 1,
          }}>
            {saving ? "Saving..." : "Confirm"}
          </button>
        </div>
      </div>
    </>
  );
};

export default ReassignModal;